import React, { forwardRef, useState } from 'react'
import {
  Box,
  Button,
  Typography,
  makeStyles,
  IconButton,
} from '@material-ui/core'
import DialogUI from 'ui/Dialog'
import { colors } from 'theme'
import { Close } from '@material-ui/icons'
import SuggestTitleContent from './SuggestTitleContent'

const DialogTitle = ({ classes, onClose }) => (
  <Box className={classes.titleWrapperBox}>
    <Box className={classes.titleTextWrapperBox} xs={10}>
      <Typography variant="h5" className={classes.titleText}>
        Suggest a Title
      </Typography>
    </Box>
    <Box xs={2} className={classes.closeIconWrapperBox}>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  </Box>
)

const CloseButton = ({ className, onClose }) => (
  <Button
    variant="contained"
    color="primary"
    className={className}
    onClick={onClose}
  >
    Close
  </Button>
)

const Dialog = (_, ref) => {
  const [showRequestFormContent, setShowRequestFormContent] = useState(true)
  const classes = useStyles()

  const onClose = () => {
    ref.current && ref.current.close && ref.current.close()
    setTimeout(setShowRequestFormContent, 100, true)
  }

  return (
    <DialogUI
      ref={ref}
      title={<DialogTitle classes={classes} onClose={onClose} />}
      maxWidth="xs"
      scroll="body"
      className={classes.container}
      actions={
        !showRequestFormContent && (
          <CloseButton className={classes.closeButton} onClose={onClose}>
            CLOSE
          </CloseButton>
        )
      }
    >
      <SuggestTitleContent
        showRequestFormContent={showRequestFormContent}
        setShowRequestFormContent={setShowRequestFormContent}
      />
    </DialogUI>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    '& p': {
      marginTop: 0,
      fontSize: '0.87rem',
      wordSpacing: '-0.06rem',
      color: colors.gray700,
    },
  },
  titleWrapperBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    '& h5': {
      paddingTop: '1em',
    },
  },
  titleTextWrapperBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleText: {
    color: colors.aqua500,
    fontWeight: 600,
    fontSize: '32px',
  },
  closeIconWrapperBox: {
    alignSelf: 'flex-end',
    lineHeight: 1.6,
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'auto',
    },
  },
  closeButton: {
    width: '100%',
    margin: theme.spacing(0, 3, 3, 3),
    backgroundColor: colors.aqua500,
    color: colors.white,
  },
}))

export default forwardRef(Dialog)
